const STORAGE_KEY_PREFIX = 'dgo_balance_hidden';

// Scoped per user so the preference is not shared between accounts on the same browser.
const getStorageKey = (userId?: number) => (userId ? `${STORAGE_KEY_PREFIX}_${userId}` : null);

export const isBalanceHidden = (userId?: number): boolean => {
  const key = getStorageKey(userId);
  if (!key) {
    return false;
  }

  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
};

export const setBalanceHidden = (userId: number | undefined, hidden: boolean): void => {
  const key = getStorageKey(userId);
  if (!key) {
    return;
  }

  try {
    if (hidden) {
      localStorage.setItem(key, 'true');
    } else {
      localStorage.removeItem(key);
    }
  } catch {
    // Storage can be unavailable (private mode / quota); the toggle still works for the session.
  }
};
